export const PRODUCTS = ['life', 'disability', 'ci']
export const PRODUCT_PRETTY_NAME_MAP = {
  'life': 'Life',
  'disability': 'Disability',
  'lifeDisability': 'Life/Disability',
  'ci': 'Critical Illness'
}